/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_tr_chars = /** @type {(inputs: { n: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.n} characters`)
};

const es_tr_chars = /** @type {(inputs: { n: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.n} caracteres`)
};

const de_tr_chars = /** @type {(inputs: { n: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.n} Zeichen`)
};

const nl_tr_chars = /** @type {(inputs: { n: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.n} tekens`)
};

const fr_tr_chars = /** @type {(inputs: { n: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.n} caractères`)
};

const it_tr_chars = /** @type {(inputs: { n: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.n} caratteri`)
};

const pt_br2_tr_chars = /** @type {(inputs: { n: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.n} caracteres`)
};

const pt_tr_chars = /** @type {(inputs: { n: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.n} caracteres`)
};

const ja_tr_chars = /** @type {(inputs: { n: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.n}文字`)
};

const zh_tr_chars = /** @type {(inputs: { n: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.n} 个字符`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{ n: NonNullable<unknown> }} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const tr_chars = (inputs, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.tr_chars(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("tr_chars", locale)
	if (locale === "en") return en_tr_chars(inputs)
	if (locale === "es") return es_tr_chars(inputs)
	if (locale === "de") return de_tr_chars(inputs)
	if (locale === "nl") return nl_tr_chars(inputs)
	if (locale === "fr") return fr_tr_chars(inputs)
	if (locale === "it") return it_tr_chars(inputs)
	if (locale === "pt-BR") return pt_br2_tr_chars(inputs)
	if (locale === "pt") return pt_tr_chars(inputs)
	if (locale === "ja") return ja_tr_chars(inputs)
	return zh_tr_chars(inputs)
};